import type { Table } from '@tanstack/react-table'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type OrganizationUsersTableToolbarProps<TData> = {
  table: Table<TData>
  searchPlaceholder: string
  resetLabel: string
}

export function OrganizationUsersTableToolbar<TData>({
  table,
  searchPlaceholder,
  resetLabel,
}: OrganizationUsersTableToolbarProps<TData>) {
  const isFiltered = Boolean(
    String(table.getState().globalFilter ?? '').trim()
  )

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-col-reverse items-start gap-y-2 sm:flex-row sm:items-center sm:gap-2">
        <Input
          placeholder={searchPlaceholder}
          value={String(table.getState().globalFilter ?? '')}
          onChange={(event) => table.setGlobalFilter(event.target.value)}
          className="h-8 w-full sm:w-[150px] lg:w-[250px]"
        />
        {isFiltered && (
          <Button
            variant="ghost"
            type="button"
            onClick={() => table.setGlobalFilter('')}
            className="h-8 px-2 lg:px-3"
          >
            {resetLabel}
            <X className="ms-2 size-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
